import { Table, type TableProps } from "@mantine/core"
import type { ReactNode } from "react"

export function DataTableShell({
  children,
  minWidth = 720,
  ...props
}: TableProps & { children: ReactNode; minWidth?: number }) {
  return (
    <Table.ScrollContainer minWidth={minWidth}>
      <Table striped highlightOnHover withTableBorder {...props}>
        {children}
      </Table>
    </Table.ScrollContainer>
  )
}
